import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges,
  inject
} from '@angular/core';

import { PlatformService } from '@hdms/shared/util-core';

const MAX_WITH = 'max-width';

@Directive({
  selector: '[shrdPfUiMaxWidth]'
})
export class MaxWidthDirective implements AfterViewInit, OnChanges {
  private readonly hostEl = inject(ElementRef<HTMLElement>).nativeElement;
  private readonly isBrowser = inject(PlatformService).isBrowser;
  private readonly renderer = inject(Renderer2);

  @Input() shrdPfUiMaxWidth?: string;
  @Input() update?: unknown;

  ngAfterViewInit(): void {
    this.setMaxWidth();
  }

  /**
   * Recalculate maxWidth on subsequent content updates.
   * Delay recalculation to give time for content changes being rendered.
   * @param update
   */
  ngOnChanges({ update }: SimpleChanges): void {
    if (update && !update.firstChange) {
      this.renderer.removeStyle(this.hostEl, MAX_WITH);
      setTimeout(() => this.setMaxWidth());
    }
  }

  private setMaxWidth(): void {
    this.isBrowser &&
      this.renderer.setStyle(this.hostEl, MAX_WITH, this.shrdPfUiMaxWidth || `${this.hostEl.scrollWidth + 5}px`);
  }
}
